import { compose, withHandlers } from 'recompose';
import { withDataLayerPush } from './withDataLayerPush';

export const withDataLayerEPhotobookPreviewPush = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerEPhotobookPreviewPush: ({ dataLayerPush }) => ({
      ephotobookPreviewViewerType
    }) => {
      dataLayerPush({
        event: 'ephotobookPreview',
        ephotobookPreviewViewerType
      });
    }
  })
);



// WEBPACK FOOTER //
// ./src/Common/GTM/withDataLayerEPhotobookPreview.js